import React, { useState } from 'react';
import './MainLayout.scss';
import AppMenu from '../components/AppMenu/AppMenu';
import AppTopBar from '../components/AppTopBar/AppTopBar';
import { connect } from 'react-redux';
import VirtualAccountModal from '../components/VirtualAccountModal/VirtualAccountModal';
import * as actionCreator from '../actions/';
import PageInformation from '../components/PageInformation';

const MainLayout = ({ pageTitle, showVAccountModal, classNames, children }) => {
    const [appMenuStatus, setAppMenuStatus] = useState(false);
    return (
        <PageInformation title={pageTitle + ' - Client Portal'}>
            {showVAccountModal ? <VirtualAccountModal /> : null}
            <AppMenu isMenuOpen={appMenuStatus} />
            <AppTopBar
                toggleAppMenuStatus={() => setAppMenuStatus(!appMenuStatus)}
                pageTitle={pageTitle}
            />
            <div className={`app-page-content ${classNames}`}>{children}</div>
        </PageInformation>
    );
};

const mapStateToProps = (appState) => ({
    showVAccountModal: appState.showVAccountModal,
});

const mapDispatchToProps = (dispatch) => ({
    setShowVirtualAccount: () =>
        dispatch(actionCreator.Session.setShowVirtualAccount(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
